import { apiGet, apiPost } from './apiClient';

const buildQuery = (params = {}) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') qs.set(k, v);
  });
  const str = qs.toString();
  return str ? `?${str}` : '';
};

export const listConversations = (token, params = {}) =>
  apiGet(`/api/host/conversations${buildQuery(params)}`, token);

export const getMessages = (conversationId, token, params = {}) =>
  apiGet(`/api/host/conversations/${conversationId}/messages${buildQuery(params)}`, token);

export const sendMessage = (conversationId, text, token) =>
  apiPost(`/api/host/conversations/${conversationId}/messages`, { text }, token);

export const markRead = (conversationId, token) =>
  apiPost(`/api/host/conversations/${conversationId}/mark-read`, {}, token);

export const flagConversation = (conversationId, reason, token) =>
  apiPost(`/api/host/conversations/${conversationId}/flag`, { reason }, token);
